import actions from '@lib/analytics/emarsys/actions'

const { purchaseEvent, setEmailEvent } = actions

const getOrder = (data: Booking.Confirmation): PurchaseOrder => {
  const { booking, outboundConnection, inboundConnection } = data

  return {
    orderId: booking.id,
    items: [
      {
        item: outboundConnection.id,
        currency: booking.totalPrice.currency,
        price: booking.totalPrice.fractional / 100,
        quantity: [outboundConnection, inboundConnection].filter(Boolean).length * booking.pax,
      },
    ],
  }
}

const sendPurchase = (data: Booking.Confirmation) => {
  setEmailEvent(data.booking.email)

  purchaseEvent(getOrder(data))
}

export default {
  sendPurchase,
}
